<div style="margin-bottom: 3rem">
  <h3>{{ 'dashboard.membership-activity.title' | translate | titlecase }}</h3>
</div>
<div class="mct-flex mct-col mct-gap-2rem mct-gap-1rem-lt-md"   >
  <div class="mct-flex mct-col mct-gap-2rem mct-gap-1rem-lt-md"   >
    <wl-card>
      <div class="mct-flex mct-col mct-gap-2rem"  >
        <div class="mct-flex mct-row mct-wrap mct-gap-10"  >
          <wl-date-selector name="startDate" [(ngModel)]="startDate" (onDateChanged)="selectedDateChange()"></wl-date-selector>
          <div class="mct-flex mct-col mct-justify-center mct-items-center" style="min-height: 100%"  >
            {{ 'common.through' | translate }}
          </div>
          <wl-date-selector name="endDate" [(ngModel)]="endDate" (onDateChanged)="selectedDateChange()"></wl-date-selector>
        </div>
        <div>
          <p-table [showGridlines]="true" #membershipActivityGrid [ngClass]=" showMembershipActivityDetails ? 'wl-responsive-prime-datatable-borderless' : 'wl-responsive-prime-datatable-borderless body-hidden' " [value]="membershipActivityDetails" [paginator]="false" styleClass="wl-responsive-prime-datatable-borderless">
            <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
              <SortAltIcon *ngIf="sortOrder === 0">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
              </SortAltIcon>
              <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
              </SortAmountUpAltIcon>
              <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
              </SortAmountDownIcon>
            </ng-template>
            <ng-template pTemplate="header">
              <tr class="wl-prime-datatable-hidden-phone">
                <th style="width: 22%; text-align: left !important">
                  <a
                    (click)="toggleMembershipActivityDetails()"
                    [ngClass]="{ 'wl-dashboard-open-close-open': showMembershipActivityDetails }"
                    [hidden]="membershipActivityDetails.length == 1"
                  >
                    <span class="wl-dashboard-open-close-icon glyphicon glyphicon-chevron-up"></span>
                    <ng-container *ngIf="!showMembershipActivityDetails">
                      <span>{{ 'dashboard.membership-activity.show-all-levels' | translate | titlecase }}</span>
                    </ng-container>
                    <ng-container *ngIf="showMembershipActivityDetails">
                      <span>{{ 'dashboard.membership-activity.show-totals-only' | translate | titlecase }}</span>
                    </ng-container>
                  </a>
                </th>
                <th>
                  <span>{{ 'dashboard.membership-activity.new-members' | translate | titlecase }}</span>
                </th>
                <th>
                  <span>{{ 'dashboard.membership-activity.new-investment' | translate | titlecase }}</span>
                </th>
                <th>
                  <span>{{ 'dashboard.membership-activity.dropped-members' | translate | titlecase }}</span>
                </th>
                <th>
                  <span>{{ 'dashboard.membership-activity.lost-investment' | translate | titlecase }}</span>
                </th>
                <th>
                  <span>{{ 'dashboard.membership-activity.gain-loss' | translate | titlecase }}</span>
                </th>
                <th>
                  <span>{{ 'dashboard.membership-activity.gain-loss-investment' | translate | titlecase }}</span>
                </th>
                <th>
                  <span>{{ 'dashboard.membership-activity.total-members' | translate | titlecase }}</span>
                </th>
              </tr>
              <tr class="wl-prime-datatable-hidden-tablet-and-bigger">
                <th style="text-align: left !important">
                  <a
                    (click)="toggleMembershipActivityDetails()"
                    [ngClass]="{ 'wl-dashboard-open-close-open': showMembershipActivityDetails }"
                  >
                    <span class="wl-dashboard-open-close-icon glyphicon glyphicon-chevron-down"></span>
                    <span *ngIf="!showMembershipActivityDetails">
                      &nbsp;{{ 'dashboard.membership-activity.show-all-levels' | translate | titlecase }}
                    </span>
                    <span *ngIf="showMembershipActivityDetails">
                      &nbsp;{{ 'dashboard.membership-activity.show-totals-only' | translate | titlecase }}
                    </span>
                  </a>
                </th>
              </tr>
            </ng-template>
            <ng-template let-level pTemplate="body">
              <tr class="table-cell-text-right-align wl-prime-datatable-hidden-phone" [hidden]="!showMembershipActivityDetails">
                <td style="text-align: left !important">
                  {{ level.MembershipLevel }}
                </td>
                <td>
                  {{ level.NewMembers }}
                </td>
                <td>
                  {{ level.NewInvestment | currency }}
                </td>
                <td>
                  {{ level.DroppedMembers }}
                </td>
                <td>
                  {{ level.LostInvestment | currency }}
                </td>
                <td>
                  {{ level.GainLoss | negativeParens }}
                </td>
                <td>
                  {{ level.GainLossInvestment | currency }}
                </td>
                <td>
                  {{ level.TotalMembers }}
                </td>
              </tr>
              <tr class="wl-prime-datatable-hidden-tablet-and-bigger" [hidden]="!showMembershipActivityDetails">
                <td style="text-align: left !important">
                  <h4>{{ level.MembershipLevel }}</h4>
                  <span style="font-weight: bold"> {{ 'dashboard.membership-activity.new-members' | translate | titlecase }}: </span
                  >&nbsp;&nbsp;{{ level.NewMembers }}<br />
                  <span style="font-weight: bold"> {{ 'dashboard.membership-activity.new-investment' | translate | titlecase }}: </span
                  >&nbsp;&nbsp;{{ level.NewInvestment | currency }}<br />
                  <span style="font-weight: bold"> {{ 'dashboard.membership-activity.dropped-members' | translate | titlecase }}: </span
                  >&nbsp;&nbsp;{{ level.DroppedMembers }}<br />
                  <span style="font-weight: bold"> {{ 'dashboard.membership-activity.lost-investment' | translate | titlecase }}: </span
                  >&nbsp;&nbsp;{{ level.LostInvestment | currency }}<br />
                  <span style="font-weight: bold"> {{ 'dashboard.membership-activity.gain-loss' | translate | titlecase }}: </span
                  >&nbsp;&nbsp;{{ level.GainLoss | negativeParens }}<br />
                  <span style="font-weight: bold">
                    {{ 'dashboard.membership-activity.gain-loss-investment' | translate | titlecase }}: </span
                  >&nbsp;&nbsp;{{ level.GainLossInvestment | currency }}<br />
                  <span style="font-weight: bold"> {{ 'dashboard.membership-activity.total-members' | translate | titlecase }}: </span
                  >&nbsp;&nbsp;{{ level.TotalMembers }}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr class="table-cell-text-right-align wl-prime-datatable-hidden-phone footer">
                <td style="text-align: left !important">
                  <span>{{ 'dashboard.membership-activity.membership-activity-totals' | translate | titlecase }}</span>
                </td>
                <td>
                  <span>{{ membershipActivityTotals.NewMembers }}</span>
                </td>
                <td>
                  <span>{{ membershipActivityTotals.NewInvestment | currency }}</span>
                </td>
                <td>
                  <span>{{ membershipActivityTotals.DroppedMembers }}</span>
                </td>
                <td>
                  <span>{{ membershipActivityTotals.LostInvestment | currency }}</span>
                </td>
                <td>
                  <span>{{ membershipActivityTotals.GainLoss | negativeParens }}</span>
                </td>
                <td>
                  <span>{{ membershipActivityTotals.GainLossInvestment | currency }}</span>
                </td>
                <td>
                  <span>{{ membershipActivityTotals.TotalMembers }}</span>
                </td>
              </tr>
              <tr class="wl-text-left wl-prime-datatable-hidden-tablet-and-bigger">
                <td style="text-align: left !important">
                  <h4>{{ 'dashboard.membership-activity.membership-activity-totals' | translate | titlecase }}</h4>
                  <span style="font-weight: bold"> {{ 'dashboard.membership-activity.new-members' | translate | titlecase }}: </span
                  >&nbsp;&nbsp;{{ membershipActivityTotals.NewMembers }}<br />
                  <span style="font-weight: bold"> {{ 'dashboard.membership-activity.new-investment' | translate | titlecase }}: </span
                  >&nbsp;&nbsp;{{ membershipActivityTotals.NewInvestment | currency }}<br />
                  <span style="font-weight: bold"> {{ 'dashboard.membership-activity.dropped-members' | translate | titlecase }}: </span
                  >&nbsp;&nbsp;{{ membershipActivityTotals.DroppedMembers }}<br />
                  <span style="font-weight: bold"> {{ 'dashboard.membership-activity.lost-investment' | translate | titlecase }}: </span
                  >&nbsp;&nbsp;{{ membershipActivityTotals.LostInvestment | currency }}<br />
                  <span style="font-weight: bold"> {{ 'dashboard.membership-activity.gain-loss' | translate | titlecase }}: </span
                  >&nbsp;&nbsp;{{ membershipActivityTotals.GainLoss | negativeParens }}<br />
                  <span style="font-weight: bold">
                    {{ 'dashboard.membership-activity.gain-loss-investment' | translate | titlecase }}: </span
                  >&nbsp;&nbsp;{{ membershipActivityTotals.GainLossInvestment | currency }}<br />
                  <span style="font-weight: bold"> {{ 'dashboard.membership-activity.total-members' | translate | titlecase }}: </span
                  >&nbsp;&nbsp;{{ membershipActivityTotals.TotalMembers }}
                </td>
              </tr>
            </ng-template>
          </p-table>

        </div>
        <div [hidden]="hideRetention">
          <wl-dashboard-neo-retention #retentionReport></wl-dashboard-neo-retention>
        </div>
      </div>
    </wl-card>
  </div>
  <div class="mct-flex mct-col mct-gap-2rem mct-gap-1rem-lt-md"    [hidden]="hideRetention">
    <div class="mct-grid neo-activity-grid mct-grid-lt-md mct-cols-1-lt-md mct-gap-32"    id="retention-charts">
      <wl-card>
        <wl-dashboard-neo-retention-donut #retentionDonut></wl-dashboard-neo-retention-donut>
      </wl-card>
      <wl-card>
        <wl-dashboard-neo-retention-monthly #addDropChart></wl-dashboard-neo-retention-monthly>
      </wl-card>
    </div>
  </div>
</div>
